<template>
	<div class="content text-white">
		<div class="text-3.5xl mb-3">Tambah Rekening Bank</div>
		<div class="text-xs mb-8">
			<Breadcrumbs />
		</div>

		<div class="grid grid-cols-70-30 gap-12">
			<div>
				<div class="card rounded-b-none p-5 mb-0.5">
					<Banner text="Pastikan kepemilikan nomor rekening yang dimasukkan atas nama Anda" iconColor_prop="gold"
						class="mb-5" />

					<div class="flex justify-center items-center flex--same-width mb-5">
						<label class="text-white" for="bank">Bank</label>
						<div v-if="isLoadingGetBankList" class="text-right">
							<Loader />
						</div>

						<div v-else-if="bankList.length < 1" class="text-right">
							<span class="mr-5">Gagal memuat data</span>
							<!-- button retry -->
							<button class="btn bg-theme" @click="setBankList">Retry</button>
						</div>

						<Select v-else :options="bankOptions" placeholderProp="Pilih Bank" v-model="bankChosen" />
					</div>

					<div class="flex justify-center items-center flex--same-width mb-5">
						<label class="text-white" for="accountNumber">Nomor Rekening</label>
						<InputComponent type="text" :numberOnly="true" placeholder="Masukkan no rekening" v-model="accountNumber" />
						<!-- <div>
							<input class="input" type="text" placeholder="Masukkan no rekening" v-model="accountNumber">
						</div> -->
					</div>

					<div v-if="isLoadingAddBankAccount" class="flex justify-center items-center">
						<Loader />
					</div>

					<div v-else-if="addBankAccountStatus == 'verified'">
						<Banner class="mb-5" type="success">
							<div class="text-sm">
								<div class="mb-3">Nomor rekening sesuai</div>
								<div class="flex gap-3">
									<div>
										<img :src="logoSearch(addBankAccountVerifiedData.logoCode)" alt="" class="h-5 w-5">
									</div>
									<div class="font-bold">{{ addBankAccountVerifiedData.accountName }}</div>
								</div>
							</div>
						</Banner>
					</div>

				</div>

				<div class="card rounded-t-none p-5">
					<button class="btn c-btn-theme w-full" :disabled="addBankAccountStatus != 'verified'"
						@click="nextStep()">Verifikasi</button>
				</div>
			</div>

			<!-- Daftar Rekening Penerima -->
			<div>
				<div class="card rounded-b-none p-5 mb-0.5">
					<div class="text-sm">Daftar Rekening Penerima</div>
				</div>

				<div class="card rounded-t-none p-5">
					<template v-if="isLoadingBankListApproved">
						<div class="flex justify-center items-center">
							<Loader />
						</div>
					</template>

					<template v-else-if="isErrorBankListApproved">
						<div class="text-center mb-5">Gagal memuat data</div>
						<!-- button retry -->
						<button class="btn bg-theme w-full" @click="setBankListApproved">Retry</button>
					</template>

					<template v-else-if="bankListApproved.length < 1">
						<div class="text-xs text-center">Anda belum memiliki rekening bank yang disetujui</div>
					</template>

					<template v-else>
						<div v-for="item in bankListApproved" class="flex items-center gap-3 mb-5" :key="item._id">
							<div class="w-6">
								<!-- <LogoAbi size_prop="1.5em" /> -->
								<img :src="item.bankLogo" alt="Logo" />
							</div>
							<div class="text-xs">
								<div class="mb-1">
									{{ item.accountName }}
									<span :class="[`${item.status == 'Verified' ? 'success' : 'gold'}`, 'ml-2']">
										{{ item.status }}
									</span>
								</div>
								<div>{{ item.bankName }} - {{ item.accountNumber }}</div>
							</div>
						</div>
					</template>

				</div>
			</div>

		</div>
		<router-view></router-view>
	</div>
</template>

<script>
import useBankAccount from '../../composable/useBankAccount'
import { debounce } from '../../utils/debounce'
import { logoSearch } from '../../utils/logoSearch'

import Banner from '@/components/Banner.vue'
import Select from '@/components/ui/Select.vue'
import LogoAbi from '@/components/logo/LogoAbi.vue'
import Alert from '@/components/alert-component/AlertComponent.js'
import router from '../../router'
import Breadcrumbs from '../../components/Breadcrumbs.vue'
import Loader from '../../components/Loader.vue'
import InputComponent from '../../components/InputComponent.vue'

export default {
	name: 'AddBankAccount',

	mixins: [useBankAccount],

	components: {
		Banner,
		Select,
		LogoAbi,
		Breadcrumbs,
		Loader,
		InputComponent
	},

	data() {
		return {
			bankChosen: '',
			accountNumber: '',

			debouncedSearch: null
		}
	},

	computed: {
		bankOptions() {
			return this.bankList.map(bank => {
				const logoCode = logoSearch(bank.code, 'bankSquare')
				return {
					value: bank.code,
					label: bank.name,
					logo: logoCode
				}
			})
		}
	},

	watch: {
		bankChosen() {
			this.verified()
		},

		accountNumber() {
			this.verified()
		}
	},

	created() {
		this.setBankList()
		this.setBankListApproved({
			status: "ACCEPTED"
		})
		this.debouncedSearch = debounce(this.addBankAccountFunc, 520)
	},

	methods: {
		logoSearch(code) {
			return logoSearch(code, 'bankSquare')
		},

		verified() {
			if (!this.bankChosen || !this.accountNumber) {
				return
			} else {
				this.isLoadingAddBankAccount = true
				this.debouncedSearch()
			}
		},

		addBankAccountFunc() {
			this.addBankAccount({
				"bank_code": this.bankChosen.value,
				"account_no": this.accountNumber,
			})
		},

		nextStep() {
			Alert.open({
				type: 'confirm',
				title: 'Persetujuan Pengguna',
				description: 'Saya setuju untuk data terkait dengan nomor rekening yang saya masukkan untuk diverifikasi lebih lanjut oleh JFXGOLD X',
				onConfirm: async () => {
					this.$store.commit('bankAccount/setWhichProcessAddBankAccount', 'verify')
					this.$router.push({ name: 'Identity Verification' })
				}
			})
		},
	},

	// beforeRouteUpdate(to, from, next) {
	// 	// just use `this`
	// 	const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
	// 	if (answer) {
	// 		next()
	// 	} else {
	// 		next(false)
	// 	}
	// },

	// beforeRouteLeave(to, from, next) {
	// 	let answer

	// 	if (this.$store.state.bankAccount.requestKeyAddBankAccount) {
	// 		answer = true
	// 	} else {
	// 		answer = window.confirm('Do you really want to leave? you have unsaved changes!')
	// 	}

	// 	if (answer) {
	// 		next()
	// 	} else {
	// 		next(false)
	// 	}
	// }
}
</script>

<style scoped>
.norek {
	margin-bottom: 0.125rem;
}

.card {
	background-color: var(--grey-4-color);
}

.logo-bagi {
	width: 1.5em;
	height: 1.5em;
}
</style>
